(function(){
  var textColor = '#d7dce1';
  var linkColor = '#ffffff';

  function setImportant(node, property, value){
    if (node && node.style) node.style.setProperty(property, value, 'important');
  }

  function prepareHosts(root){
    root.querySelectorAll('[data-pp-message]').forEach(function(node){
      node.setAttribute('data-pp-style-text-color', 'white');
      node.setAttribute('data-pp-style-logo-type', node.getAttribute('data-pp-style-logo-type') || 'inline');
    });

    root.querySelectorAll('paypal-message,paypal-messages').forEach(function(node){
      node.setAttribute('text-color', 'WHITE');
      if ('textColor' in node) node.textColor = 'WHITE';
    });
  }

  function styleMessages(root){
    root.querySelectorAll('.message_container .message,.message_container .message__headline,.message_container .message__sub-headline,.message_container .message__disclaimer').forEach(function(node){
      setImportant(node, 'color', textColor);
    });

    root.querySelectorAll('.message_container a,.message_container .message__disclaimer a').forEach(function(node){
      setImportant(node, 'color', linkColor);
    });
  }

  function visitOpenShadows(root){
    root.querySelectorAll('*').forEach(function(node){
      if (node.shadowRoot) apply(node.shadowRoot);
    });
  }

  function visitFrames(root){
    root.querySelectorAll('iframe').forEach(function(frame){
      try {
        if (frame.contentDocument) apply(frame.contentDocument);
      } catch (error) {
        // Cross-origin PayPal frames cannot be styled from the theme.
      }
    });
  }

  function apply(root){
    if (!root || !root.querySelectorAll) return;
    prepareHosts(root);
    styleMessages(root);
    visitOpenShadows(root);
    visitFrames(root);
  }

  function run(){
    apply(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  [250, 750, 1500, 3000].forEach(function(delay){
    window.setTimeout(run, delay);
  });

  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
